import React, { Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { HyperText } from '../components/HyperText';
import { WordFadeIn } from '../components/ui/WordFadeIn';
import { motion } from 'framer-motion';
// Lazy load the WhatWeDoFeature component
const WhatWeDoFeature = lazy(() => import('../components/WhatWeDoFeature'));
const HomePage = () => {
  return <div className="w-full" data-id="element-363">
      {/* Hero Section with Video Background */}
      <div className="relative w-full h-screen overflow-hidden" data-id="element-364">
        {/* Video Background */}
        <iframe src="https://player.vimeo.com/video/1113230689?background=1&autoplay=1&loop=1&byline=0&title=0&portrait=0&muted=1&controls=0" className="absolute top-1/2 left-1/2 w-full h-full min-w-full min-h-full object-cover z-0" style={{
        transform: 'translate(-50%, -50%)',
        width: '100vw',
        height: '56.25vw',
        minHeight: '100vh',
        minWidth: '177.78vh' // 16:9 aspect ratio
      }} frameBorder="0" allow="autoplay; fullscreen" title="ChiroVenture Background Video" data-id="element-365" />
        {/* Video Overlay */}
        <div className="absolute inset-0 bg-teal-900/30 z-10" data-id="element-366"></div>
        {/* Hero Content */}
        <div className="relative z-20 flex flex-col justify-end h-full pb-16 px-4 sm:px-6" data-id="element-367">
          <div className="max-w-7xl mx-auto w-full opacity-0 animate-[fadeIn_0.5s_ease-in_0.3s_forwards]" data-id="element-368">
            <div className="max-w-lg" data-id="element-369">
              <WordFadeIn words="Next Generation Chiropractic Management" className="text-2xl sm:text-3xl md:text-4xl font-light text-white mb-4 font-display leading-tight tracking-normal" delay={0.3} data-id="element-370" />
              <WordFadeIn words="We are a next generation professional management company dedicated to driving operational excellence and enterprise value in the chiropractic industry." className="text-sm sm:text-base md:text-lg text-white mb-6 leading-relaxed font-light" delay={0.4} variants={{
              hidden: {
                opacity: 0,
                y: 10
              },
              visible: (i: number) => ({
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.4 + i * 0.02,
                  duration: 0.2
                }
              })
            }} data-id="element-371" />
              <Link to="/contact" className="inline-block px-6 py-3 bg-[#4ECDC4] text-white rounded-lg font-light transition-all transform hover:scale-105 hover:bg-[#4ECDC4]/90" data-id="element-372">
                Partner with us today
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Content Section */}
      <div className="bg-center bg-cover bg-no-repeat py-12 sm:py-16 md:py-24 bg-gray-900" data-id="element-373">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-374">
          <div className="text-center mb-10 sm:mb-16" data-id="element-375">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-white mb-8 sm:mb-12 tracking-normal" data-id="element-376">
              What We Do
            </h2>
            {/* Suspense boundary for lazy-loaded component */}
            <Suspense fallback={<div className="h-[350px] flex items-center justify-center" data-id="element-378">
                  <div className="animate-pulse text-white" data-id="element-379">Loading...</div>
                </div>} data-id="element-377">
              <div className="flex justify-center mb-8 sm:mb-16 overflow-hidden" data-id="element-380">
                <WhatWeDoFeature badgeTexts={{
                first: 'Partner',
                second: 'Consolidate',
                third: 'Integrate'
              }} buttonTexts={{
                first: 'Excellence',
                second: 'Innovation'
              }} title="Comprehensive Chiropractic Solutions" circleText="Why" description="To empower the chiropractic industry and maximize holistic healthcare through acquisition, resource consolidation, and service integration." lightColor="#4ECDC4" data-id="element-381" />
              </div>
            </Suspense>
          </div>
          <div className="max-w-2xl mx-auto bg-gray-900/50 p-4 sm:p-6 rounded-2xl border border-[#4ECDC4] text-white transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(78,205,196,0.3)] mt-20 sm:mt-32" data-id="element-382">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6" data-id="element-383">
              <div className="flex-shrink-0" data-id="element-384">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mvX2EXGqoaH7VgYApbh4X3/Dr._Gaby_Sabatino_headshot.png" alt="Dr. Gaby Sabatino" className="w-16 h-16 sm:w-20 sm:h-20 object-cover object-center rounded-full border-2 border-[#4ECDC4]" loading="lazy" data-id="element-385" />
              </div>
              <div data-id="element-386">
                <p className="text-gray-300 leading-relaxed font-light italic mb-4 text-sm sm:text-base" data-id="element-387">
                  "As a chiropractor, I went through several coaching programs,
                  but they never addressed my main concerns. What I needed was
                  an actual business partner, a successor, a management team,
                  and a sounding board. This is why Chiro Venture exists... to
                  invest in your clinic, staff, patients, and ultimately, your
                  legacy."
                </p>
                <div className="flex items-center gap-2 justify-center sm:justify-start" data-id="element-388">
                  <h3 className="text-base sm:text-lg font-light tracking-normal" data-id="element-389">
                    Dr. Gaby Sabatino, D.C.
                  </h3>
                  <span className="text-gray-400 text-xs sm:text-sm font-light" data-id="element-390">
                    • Vice President
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default HomePage;